import { extendTheme } from "@chakra-ui/react";

/**
 * Default theme colors, generated using UIColor for friendly consistency.
 * Change values here to effect change for entire app.
 */

const theme = extendTheme({
  colors: {
    primary: "#810CA8", // Set primary color
    secondary: "#C147E9", // Set secondary color
    background: "#2D033B", // Set background color
    text: "#E5B8F4", // Set text color
    textSecondary: "#DDE6ED", // Set secondary text color
  },
});

export default theme;
